import { createPremiumModule } from '@wix/premium-fed-sdk/@premium-module';
import { ModalsExtension, SharedModalsExtension } from './ModalsExtension';
export const ModalsModule = createPremiumModule('modals', [ModalsExtension, SharedModalsExtension]);
//# sourceMappingURL=ModalsModule.js.map